import { useQuery } from '@apollo/client/react';
import { sortBy } from 'lodash-es';
import { useMemo } from 'react';

import { GET_JOB_TITLES, GetJobTitlesData } from '@pflegia/ui/shared/graphql/job-title';
import useJobTitle from '@pflegia/ui/shared/job-title/hooks/use-job-title';

type JobTitleFilterOptionData = Pick<GetJobTitlesData['allJobTitles'][number], 'id' | 'title' | 'deputy'>;

export interface JobTitleFilterValue {
  value: string;
  text: string;
  jobTitle: JobTitleFilterOptionData;
}

const useJobTitlesFilterList = (
  jobBoard = false,
): {
  isLoading: boolean;
  jobTitles: JobTitleFilterValue[];
} => {
  const { translateJobTitle } = useJobTitle();

  const { data, loading } = useQuery<GetJobTitlesData>(GET_JOB_TITLES);

  const sortedJobTitles = useMemo(
    () =>
      sortBy(
        data?.allJobTitles.map(jobTitle => ({ ...jobTitle, translated: translateJobTitle(jobTitle) })),
        ({ translated }) => translated.toLowerCase(),
      ),
    [data?.allJobTitles, translateJobTitle],
  );

  const jobTitles = useMemo(
    () =>
      sortedJobTitles.map(jobTitle => ({
        value: jobBoard ? jobTitle.title : jobTitle.id,
        text: jobTitle.translated,
        jobTitle,
      })),
    [sortedJobTitles, jobBoard],
  );

  return { jobTitles, isLoading: loading };
};

export default useJobTitlesFilterList;
